import React from 'react'
import {Skeleton} from '@mui/material';

export default function LoadingLine({
  width = '100%',
  height = 52,
  dark
}) {
  return (
    <Skeleton variant="rectangular" width={width} height={height} sx={{
      ...(dark && {'background-color': 'rgba(33, 43, 54, 0.11)'})
    }} />
  )
}
